import { PeripheralTypeEnum } from "./enums/PeripheralTypeEnum";
import { StatusEnum } from "./status/StatusEnum";
import { GlobalStatusEnum } from "./status/GlobalStatusEnum";

export class InstallationPeripheral {
    id: number = -1;
    installationName: string = null;
    type: PeripheralTypeEnum = PeripheralTypeEnum.Unknown;
    globalStatus: GlobalStatusEnum = GlobalStatusEnum.Unknown;
    status: StatusEnum = StatusEnum.Unknown;
    extension: string = null;

    // constructor(id: number, type: PeripheralTypeEnum, globalStatus: GlobalStatusEnum, status: StatusEnum, extension: string) {
    //     this.id = id;
    //     this.type = type;
    //     this.globalStatus = globalStatus;
    //     this.status = status;
    //     this.extension = extension;
    // }

    constructor() { }

    public parse(obj: any) {
        if (obj.Id)
            this.id = obj.Id;
        if (obj.InstallationName)
            this.installationName = obj.InstallationName;
        if (obj.Type != null && Object.values(PeripheralTypeEnum).includes(obj.Type))
            this.type = obj.Type;
        if (obj.GlobalStatus != null && Object.values(GlobalStatusEnum).includes(obj.GlobalStatus))
            this.globalStatus = obj.GlobalStatus;
        if (obj.Status != null && Object.values(StatusEnum).includes(obj.Status))
            this.status = obj.Status;
        if (obj.Extension)
            this.extension = obj.Extension;
    }



}